import Cookies from 'js-cookie'
import { useCallback, useEffect, useRef, useState } from 'react'
import { Modal, Spinner } from 'react-bootstrap'
import config from '../../../../config'
import { GridContainer, TextRight, StatusText } from '../../styles'
import { getBackgroundColorByTransactionStatus } from '../../utils'

const QRPaymentDetailModal = ({ isShow, onHide, transactionNo, onClickPayment }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [transaction, setTransaction] = useState(null)
  const [payment, setPayment] = useState(null)

  const debounceTimer = useRef(null)
  const debounce = useCallback((fn, timeout) => {
    clearTimeout(debounceTimer.current)
    debounceTimer.current = setTimeout(() => {
      fn()
    }, timeout)
  }, [])

  const getPaymentById = useCallback(
    async (id) => {
      try {
        const headers = new Headers()
        headers.append('Authorization', `Bearer ${Cookies.get('accessToken')}`)
        const response = await fetch(`${config.apiAdminGateway}/api/v2/admin/payments/${id}`, { headers }).then((res) =>
          res.json(),
        )

        if (response.status.code !== 0) throw new Error(response.status.description)

        setPayment(response.data)
      } catch (error) {
        console.error(error)
      } finally {
        setIsLoading(false)
      }
    },
    [setPayment],
  )

  const fetchQRTransaction = useCallback(async () => {
    try {
      const headers = new Headers()
      headers.append('Authorization', `Bearer ${Cookies.get('accessToken')}`)
      const response = await fetch(`${config.apiAdminGateway}/api/v2/admin/payments/qrTransaction/${transactionNo}`, {
        headers,
      }).then((res) => res.json())

      if (response.status.code !== 0) throw new Error(response.status.description)

      setTransaction(response.data)
      getPaymentById(response.data.paymentId)
    } catch (error) {
      console.error(error)
      setTransaction(null)
    } finally {
      setIsLoading(false)
    }
  }, [getPaymentById, transactionNo])

  const handleClickPayment = () => {
    if (payment) {
      onHide?.()
      onClickPayment(payment)
    }
  }

  useEffect(() => {
    if (transactionNo && isShow) {
      fetchQRTransaction()
    }
  }, [fetchQRTransaction, isShow, transactionNo])

  return (
    <Modal show={isShow} onHide={onHide} size="lg" scrollable centered enforceFocus={false}>
      <Modal.Header closeButton>
        <Modal.Title className="text-center">
          <span>หมายเลขรายการ QR payment #{transactionNo}</span>
        </Modal.Title>
      </Modal.Header>
      {isLoading ? (
        <Modal.Body style={{ padding: '16px', display: 'flex', justifyContent: 'center' }}>
          <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </Modal.Body>
      ) : (
        <Modal.Body style={{ padding: '16px', display: 'flex', flexDirection: 'column' }}>
          {transaction ? (
            <div>
              <h4 className="text-center relative">รายละเอียด QR</h4>
              <GridContainer>
                <TextRight>หมายเลขออเดอร์ :</TextRight>
                <span>
                  {transaction?.refNo && (
                    <button
                      className="btn btn-primary"
                      style={{
                        width: 'fit-content',
                        padding: '0px 8px',
                      }}
                      onClick={() => debounce(() => handleClickPayment(payment.orderId), 300)}
                    >
                      <span>{transaction?.refNo}</span>
                    </button>
                  )}
                  (ดูสถานะการชำระเงิน)
                </span>
              </GridContainer>
              <GridContainer>
                <TextRight>สถานะ :</TextRight>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'baseline' }}>
                  <StatusText color={getBackgroundColorByTransactionStatus(transaction.status)}>
                    {transaction.status}
                  </StatusText>
                </div>
              </GridContainer>
              <GridContainer>
                <TextRight>สร้างเมื่อ :</TextRight>
                <span>{new Date(transaction?.createdAt).toLocaleString('th-TH')}</span>
              </GridContainer>
              <GridContainer>
                <TextRight>หมดอายุเมื่อ :</TextRight>
                <span>{new Date(transaction?.expiredAt).toLocaleString('th-TH')}</span>
              </GridContainer>
            </div>
          ) : (
            <span>ไม่พบข้อมูล</span>
          )}
        </Modal.Body>
      )}
    </Modal>
  )
}

export default QRPaymentDetailModal
